import Home from 'screens/home/Home';
import paths from './paths';
import UseTerms from 'screens/UseTerms';
import PrivacyPolicie from 'screens/PrivacyPolicie';
import PrivacyPoliciePDV from 'screens/PrivacyPoliciePDV';
import Contact from 'screens/Contact';
// import CheckoutOrder from 'modules/checkout/products/CheckoutOrder';
import EventPage from 'screens/EventPage';
import EstablishmentPage from 'screens/EstablishmentPage';
import EstablishmentDetailPage from 'screens/establishment/EstablishmentDetailPage';
import ProducerPage from 'screens/ProducerPage';


export default [
    {
        exact: true,
        path: paths.home,
        element: <Home />
    },

    {
        exact: true,
        path: paths.terms.policiePrivacy,
        element: <PrivacyPolicie />
    },
    
    {
        exact: true,
        path: paths.terms.useTerms,
        element: <UseTerms />
    },

    {
        exact: true,
        path: paths.terms.policiePrivacyPDV,
        element: <PrivacyPoliciePDV />
    },

    {
        exact: true,
        path: paths.contact,
        element: <Contact />
    },
    
    // {
    //     exact: false,
    //     path: `${paths.checkout.orders}/:slug`,
    //     element: <Checkout />
    // },
    
    {
        exact: false,
        path: `${paths.events.page}/:slug`,
        element: <EventPage />
    },

    {
        exact: false,
        path: paths.events.establishment(':eventSlug', ':establishmentSlug'),
        element: <EstablishmentPage />
    },

    {
        exact: false,
        path: `${paths.establishments.page}/:slug`,
        element: <EstablishmentPage />
    },

    {
        exact: false,
        path: `${paths.establishments.page}/:slug/detalhes`,
        element: <EstablishmentDetailPage />
    },

    {
        exact: false,
        path: `${paths.producer.page}/:slug`,
        element: <ProducerPage />
    },

    // {
    //     exact: false,
    //     path: paths.user.following,
    //     element: <UserFollowing />
    // },
    // {
    //     exact: false,
    //     path: paths.user.followers,
    //     element: <UserFollowers />
    // },
]